import { l } from '@manychat/manyui'

export enum InstantAnswersTab {
  SETUP = 'SETUP',
  PREVIEW = 'PREVIEW',
}

export const tabsConfig = [
  {
    label: l.makeTranslate('Setup'),
    value: InstantAnswersTab.SETUP,
    'data-test-id': 'ai-automation/open-instant-answers-setup',
  },
  {
    label: l.makeTranslate('Preview'),
    value: InstantAnswersTab.PREVIEW,
    'data-test-id': 'ai-automation/open-instant-answers-preview',
  },
]
